module.exports = __webpack_public_path__ + "fonts/iranyekanwebboldfanum.aa6ff88.woff";